import React from 'react';
import { ROUTE_TYPE_PRIVATE } from '../../../route/route-constants';
import sampleCrudTableColumns from './sample-crud-table-columns';
import { sampleCrudFields, sampleCrudValidationSchema } from './sample-crud-forms';
import { MyFormattedDate } from '../../../intl';
import SampleCrudRepository from '../../../repository/SampleCrudRepository';
import SampleCrudDetailContent from './SampleCrudDetailContent';
import SampleCrudDetailDialog from './SampleCrudDetailDialog';

export const sampleCrudCRUDOptions = {
  index: {
    enabled: true,
    tableType: 'filtered',
  },
  create: {
    enabled: true,
  },
  detail: {
    enabled: true,
    // type: 'dialog',
    // type: 'route',
    type: 'routeDialog',
  },
  edit: {
    enabled: true,
  },
  delete: {
    enabled: true,
  },
};

export const sampleCrudRoutes = {
  detail: {
    type: ROUTE_TYPE_PRIVATE,
    titleId: 'seed.crud.sample.title.detail',
    path: '/crud/detail/:id',
    exact: false,
    ComponentContent: SampleCrudDetailContent,

    componentProps: {
    },
  },
  index: {
    type: ROUTE_TYPE_PRIVATE,
    titleId: 'seed.crud.sample.title.index',
    path: '/crud',
    exact: true,

    componentProps: {
      tableColumns: sampleCrudTableColumns,
      Repository: SampleCrudRepository,
      labelIds: {
        name: 'seed.crud.sample.name',
        title: 'seed.crud.sample.title.index',
        errorLoad: 'news.error.load',
        successDelete: 'news.success.delete',
        errorDelete: 'news.error.delete',
      },
      DetailDialog: SampleCrudDetailDialog,
      deleteOptions: {
        title: 'text',
        subtitle: (rowData) => <MyFormattedDate value={new Date(rowData.date)} />,
        thumb: 'thumbnail',
      },
      defaultOrderBy: 'text',
      defaultOrderDirection: 'asc',
    },
  },
  create: {
    type: ROUTE_TYPE_PRIVATE,
    titleId: 'seed.crud.sample.title.create',
    path: '/crud/create',
    exact: true,

    componentProps: {
      fields: sampleCrudFields,
      validationSchema: sampleCrudValidationSchema,
      Repository: SampleCrudRepository,
      labelIds: {
        errorLoad: 'news.error.load',
        successCreate: 'news.success.create',
        errorCreate: 'news.error.create',
        successUpdate: 'news.success.update',
        errorUpdate: 'news.error.update',
      },
    },
  },
  edit: {
    type: ROUTE_TYPE_PRIVATE,
    titleId: 'seed.crud.sample.title.edit',
    path: '/crud/edit/:id',
    exact: false,

    componentProps: {
      fields: sampleCrudFields,
      validationSchema: sampleCrudValidationSchema,
      Repository: SampleCrudRepository,
      labelIds: {
        errorLoad: 'news.error.load',
        successUpdate: 'news.success.update',
        errorUpdate: 'news.error.update',
      },
    },
  },
};
